import React from 'react'
import { Checkbox, Footer, Grid, Header, Row } from '@plurall/elo-beta'
import { ROUTES } from 'utils/constants'
import { FormErrorMessage } from 'App/components/FormError'
import LoadingContainer from 'App/components/LoadingContainer/LoadingContainer'
import PropTypes from 'prop-types'
import styles from './SchoolDataRoleSelection.module.scss'
import ModalPending from './ModalPending'

const SchoolDataRoleSelectionRender = ({
  onSubmitForm,
  checkboxInfo,
  validateRole,
  handleChange,
  graphQLError,
  checkSelection,
  setLinkToRedirect,
  isSubmitting,
  isModalOpen,
  setIsModalOpen,
  trySubmitRoles,
  currentSchool,
}) => (
  <>
    {isSubmitting && <LoadingContainer text='Carregando informações...' fullscreen />}
    {isModalOpen && (
      <ModalPending setIsModalOpen={setIsModalOpen} trySubmitRoles={trySubmitRoles} />
    )}

    <Grid desktop={12}>
      <Row>
        <Grid desktop={3} />
        <Grid desktop={9}>
          <Header
            description={`Selecione todas as funções que você possui vínculo na escola ${currentSchool.tradeName}`}
          >
            Seleção de função
          </Header>

          <SchoolDataRoleSelectionForm
            checkboxInfo={checkboxInfo}
            validateRole={validateRole}
            handleChange={handleChange}
            graphQLError={graphQLError}
          />
        </Grid>
      </Row>
    </Grid>
    <Footer
      primaryButtonLabel='Continuar'
      secondaryButtonLabel='Cancelar'
      border
      onPrimaryButtonClick={onSubmitForm}
      onSecondaryButtonClick={() => setLinkToRedirect(ROUTES.PERFIL_DADOS_ESCOLARES)}
      isPrimaryButtonDisabled={checkSelection()}
      primaryButtonDataTestId='btn-confirm'
      secondaryButtonDataTestId='btn-cancel'
    />
  </>
)

const SchoolDataRoleSelectionForm = ({
  checkboxInfo,
  validateRole,
  handleChange,
  graphQLError,
}) => {
  const isAllChecked = !checkboxInfo.some(checkbox => !checkbox.value)
  const handleCheckAll = () => {
    checkboxInfo.forEach(checkbox => handleChange({ ...checkbox, value: !isAllChecked }))
  }

  return (
    <>
      <div className={styles.checkboxGroup}>
        <div className={styles.checkboxItem}>
          <Checkbox
            name='select-all'
            label='Selecionar todas'
            checked={isAllChecked}
            onChange={handleCheckAll}
          />
        </div>
        {checkboxInfo.map(
          checkbox =>
            validateRole(checkbox.roleID) && (
              <div className={styles.checkboxItem} key={checkbox.roleID}>
                <Checkbox
                  dataTestId={checkbox.name}
                  name={checkbox.name}
                  label={checkbox.label}
                  checked={checkbox.value}
                  onChange={() =>
                    handleChange({
                      name: checkbox.name,
                      value: !checkbox.value,
                    })
                  }
                />
              </div>
            ),
        )}
      </div>
      {graphQLError && <FormErrorMessage error={graphQLError} />}
    </>
  )
}

SchoolDataRoleSelectionRender.propTypes = {
  onSubmitForm: PropTypes.func.isRequired,
  validateRole: PropTypes.func.isRequired,
  handleChange: PropTypes.func.isRequired,
  setLinkToRedirect: PropTypes.func.isRequired,
  checkSelection: PropTypes.func.isRequired,
  graphQLError: PropTypes.string,
  checkboxInfo: PropTypes.array,
  isSubmitting: PropTypes.bool.isRequired,
  isModalOpen: PropTypes.bool.isRequired,
  setIsModalOpen: PropTypes.func.isRequired,
  trySubmitRoles: PropTypes.func.isRequired,
  currentSchool: PropTypes.object.isRequired,
}

SchoolDataRoleSelectionForm.propTypes = {
  onSubmitForm: PropTypes.func.isRequired,
  validateRole: PropTypes.func.isRequired,
  handleChange: PropTypes.func.isRequired,
  setLinkToRedirect: PropTypes.func.isRequired,
  checkSelection: PropTypes.func.isRequired,
  graphQLError: PropTypes.string,
  checkboxInfo: PropTypes.array,
}

export { SchoolDataRoleSelectionRender, SchoolDataRoleSelectionForm }
